import {action, observable} from "mobx";
import {bind} from "Mri.Web.Common";
import {AccountStore} from "../../../Account/AccountStore";
import {debounce} from "lodash";

export class GridScrollManager {
    constructor(
        private accountStore: AccountStore,
    ) {}
    
    @bind
    @action
    public initScrollListeners() {
        if(this.accountStore.storage.gridLeftPinnedContainerScrollable || this.accountStore.storage.gridRightPinnedContainerScrollable) {
            setTimeout(() => {
                const leftPinned = document.querySelector('.ag-horizontal-left-spacer') as HTMLElement;
                const rightPinned = document.querySelector('.ag-horizontal-right-spacer') as HTMLElement;
                leftPinned?.addEventListener('scroll', this.onBodyScroll);
                rightPinned?.addEventListener('scroll', this.onBodyScroll);
            }, 5000); // Delay ensures DOM is ready
        }
    }
    
    @bind
    @action
    public removeScrollListeners() {
        const leftPinned = document.querySelector('.ag-horizontal-left-spacer') as HTMLElement;
        const rightPinned = document.querySelector('.ag-horizontal-right-spacer') as HTMLElement;

        if (leftPinned) {
            leftPinned.removeEventListener('scroll', this.onBodyScroll);
        }
        if (rightPinned) {
            rightPinned.removeEventListener('scroll', this.onBodyScroll);
        }
    }

    @bind
    @action
    public restoreScrollPositions(duration: number, resetIgnore?: boolean) {
        setTimeout(() => {
            const leftPinned = document.querySelector('.ag-pinned-left-cols-container') as HTMLElement;
            const rightPinned = document.querySelector('.ag-pinned-right-cols-container') as HTMLElement;
            const centerContainer = document.querySelector('.ag-body-horizontal-scroll-viewport') as HTMLElement;

            if (leftPinned) {
                leftPinned.scrollLeft = this.accountStore.tabStorage.gridLeftScrollPosition;
            }
            if (rightPinned) {
                rightPinned.scrollLeft = this.accountStore.tabStorage.gridRightScrollPosition;
            }
            if (centerContainer) {
                centerContainer.scrollLeft = this.accountStore.tabStorage.gridCenterScrollPosition;
            }

            if(resetIgnore){
                setTimeout(() => {
                        this.ignoreScrollCapture = false;
                    }
                    , 1000);
            }
        }, duration); // Delay to ensure DOM is ready
    }
    
    @action
    public onBodyScroll = debounce(() => {
        this.handleBodyScroll();
    }, 1000);

    @bind
    @action
    private handleBodyScroll() {
        if(!this.initialScroll) {
            this.capturePinnedScrollPositions();
        }

        setTimeout(() => {
            this.initialScroll = false;
        }, 1500); // Delay to ensure DOM is ready

    }

    @bind
    @action
    private capturePinnedScrollPositions() {
        if(this.ignoreScrollCapture) return;
        
        const leftPinned = document.querySelector('.ag-pinned-left-cols-container') as HTMLElement;
        const rightPinned = document.querySelector('.ag-pinned-right-cols-container') as HTMLElement;
        const centerContainer = document.querySelector('.ag-body-horizontal-scroll-viewport') as HTMLElement;

        if (leftPinned) {
            this.accountStore.tabStorage.gridLeftScrollPosition = leftPinned.scrollLeft;
        }
        if (rightPinned) {
            this.accountStore.tabStorage.gridRightScrollPosition = rightPinned.scrollLeft;
        }
        if (centerContainer) {
            this.accountStore.tabStorage.gridCenterScrollPosition = centerContainer.scrollLeft;
        }
    }

    @observable
    public ignoreScrollCapture?: boolean = false;
    @observable
    private initialScroll?: boolean = true;
}
